import {
  addPptxBlockAuthoringSchemas,
  dispatchPptxRootByRenderer
} from "./chunk-4FGNUZM3.js";

// src/schemas/export.ts
import { convertToJsonSchema as convertSharedToJsonSchema } from "@json-to-office/shared";
function convertToJsonSchema(schema, options = {}) {
  return convertSharedToJsonSchema(schema, {
    ...options,
    enrich: (json) => {
      addPptxBlockAuthoringSchemas(json);
      dispatchPptxRootByRenderer(json);
    }
  });
}
var PPTX_COMPONENT_METADATA = {
  presentation: {
    title: "Presentation Component",
    description: "Top-level presentation container with metadata and settings"
  },
  slide: {
    title: "Slide Component",
    description: "Slide container for organizing content elements"
  },
  text: {
    title: "Text Component",
    description: "Text element with formatting and positioning"
  },
  image: {
    title: "Image Component",
    description: "Image element with sizing and positioning"
  },
  shape: {
    title: "Shape Component",
    description: "Geometric shape with optional text and styling"
  },
  table: {
    title: "Table Component",
    description: "Tabular data display with rows and columns"
  }
};
var PPTX_BASE_SCHEMA_METADATA = {
  position: {
    title: "Position",
    description: "Position and size in inches or percentages"
  },
  "slide-background": {
    title: "Slide Background",
    description: "Slide background configuration"
  },
  transition: {
    title: "Transition",
    description: "Slide transition effect configuration"
  },
  shadow: {
    title: "Shadow",
    description: "Shadow configuration for elements"
  }
};

export {
  convertToJsonSchema,
  PPTX_COMPONENT_METADATA,
  PPTX_BASE_SCHEMA_METADATA
};
//# sourceMappingURL=chunk-AD6NRP7M.js.map